import { useTranslations } from 'next-intl';

import { ProductOffer } from '@/api/backend/contract/ProductList';
import { storeUiModal } from '@/store-ui/modal';
import { UiKitButtonTab } from '@/ui-kit/button-tab';

import { styles } from './ProductVariantSelector.styles';

export interface ProductVariantSelectorProps {
  variants: ProductOffer[];
  selectedVariantId: string | null;
  onVariantClick: (variantId: string) => void;
  withoutHelper?: boolean;
  linkProduct?: string;
  showTitle?: boolean;
  accentHelper?: boolean;
}

export function ProductVariantSelector({
  variants,
  selectedVariantId,
  onVariantClick,
  withoutHelper = false,
  showTitle = false,
  accentHelper = false
}: ProductVariantSelectorProps) {
  const t = useTranslations();
  const slots = styles({
    sizeSelected: !!selectedVariantId,
    accentHelper
  });

  const handleOpenModalSizeInfoClick = () => {
    storeUiModal.getState().open('productModalSizeInfo', null);
  };

  if (!variants || variants.length === 0) return null;

  return (
    <div className={slots.base()}>
      {showTitle && <div className={slots.title()}>{t('chooseSize')}</div>}
      <div className={slots.options()}>
        {variants.map((variant) => (
          <UiKitButtonTab
            key={variant.uuid}
            active={variant.uuid === selectedVariantId}
            disabled={variant.totalStock <= 0}
            onClick={() => onVariantClick(variant.uuid)}
          >
            {variant.size}
          </UiKitButtonTab>
        ))}
      </div>
      {!withoutHelper && (
        <div className={slots.helperWrapper()}>
          <button
            type="button"
            onClick={handleOpenModalSizeInfoClick}
            className={slots.helper()}
          >
            {t('findOutSize')}
          </button>
        </div>
      )}
    </div>
  );
}
